// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Color } from '../../../Graphics';
import { LineStyle } from '../IndicatorScriptBaseEnums';
import { MAMode } from '../IndicatorConstants';
import { IndicatorScriptBase } from '../IndicatorScriptBase';
import { InputParameterInteger } from '../InputParamaterClasses/InputParameterInteger';
export class RVOLBS extends IndicatorScriptBase {
    constructor() {
        super();
        this.ProjectName = 'Relative Volume Beasley Savage';
        this.SetIndicatorLine('rvol', Color.CadetBlue, 2, LineStyle.SimpleChart);
        this.SeparateWindow = true;
        this.volumeLength = 14;
        super.InputParameter(new InputParameterInteger('volumeLength', 'Volume Length', 2, 1, 999));
    }
    Init() {
        this.IndicatorShortName(this.GetIndicatorShortName());
    }
    createInternalIndicators() {
        const volAccessor = (offset) => {
            return this.GetVolume(offset);
        };
        this.avgVolIndicator = this.Indicators.iMAOnArray(this.CurrentData, volAccessor, this.volumeLength, MAMode.SMA);
        return [this.avgVolIndicator];
    }
    GetIndicatorShortName() {
        return 'Relative Volume Beasley Savage';
    }
    OnQuote() {
        super.OnQuote();
        const curAverageVolume = this.avgVolIndicator.GetValue();
        if (curAverageVolume !== 0) {
            const relativeVolume = this.GetVolume() / curAverageVolume;
            this.SetValue(0, relativeVolume);
        }
    }
    NextBar() {
        super.NextBar();
    }
    GetVolume(x = 0) {
        const vol = this.CurrentData.Volume(x);
        return vol;
    }
}
